export enum TypeEnvironment {
  PRODUCTION = 'production',
  HOMOLOGATION = 'homologation',
  DEVELOPER = 'developer'
}